import { Dispatch } from 'redux';
import { action } from 'typesafe-actions';
import { transformBackendData } from '../../utils/adressingTransform';
import { currentWorkgroupKey, getCookieValue } from '../../utils/ajax';
import { ActionTypes, AddressingDataItem, NormalizedAddressingEntity, NormalizedAddressingRule } from '../types';

export function fetchGroupsAndSitesAsync(channelId: number) {
  return (dispatch: Dispatch<any>) => {
    const HEADER_NAME: string = process.env.REACT_APP_HEADER_01 as string;

    dispatch(fetchGroupsAndSitesRequest());

    fetch(process.env.REACT_APP_ROOT_DOMAIN + `v6/media/timelineSitesGroupsInfo/${channelId}`, {
      headers: {
        [HEADER_NAME]: getCookieValue(currentWorkgroupKey)
      }
    })
      .then(res => res.json())
      .then((data: AddressingDataItem[]) => {
        const { groups, sites, players, streams, addressingRules } = transformBackendData(data);

        dispatch(fetchGroupsAndSitesSuccess({ groups, sites, players, streams, addressingRules }));
      })
      .catch(error => dispatch(fetchGroupsAndSitesError(error)));
  };
}

export const fetchGroupsAndSitesRequest = () => action(ActionTypes.FETCH_GROUPS_AND_SITES_REQUEST);
export const fetchGroupsAndSitesSuccess = (data: {
  groups: NormalizedAddressingEntity;
  sites: NormalizedAddressingEntity;
  players: NormalizedAddressingEntity;
  streams: NormalizedAddressingEntity;
  addressingRules: NormalizedAddressingRule;
}) => action(ActionTypes.FETCH_GROUPS_AND_SITES_SUCCESS, data);
export const fetchGroupsAndSitesError = (message: string) => action(ActionTypes.FETCH_GROUPS_AND_SITES_ERROR, message);

export const selectGroup = (group: number) => action(ActionTypes.SELECT_GROUP, group);
export const selectSite = (site: number) => action(ActionTypes.SELECT_SITE, site);
export const selectPlayer = (site: number) => action(ActionTypes.SELECT_PLAYER, site);
export const restoreFilterValues = (group: number, site: number, player: number) =>
  action(ActionTypes.RESTORE_FILTERS_SELECTED_VALUES, { group, site, player });
export const clearFilterValues = () => action(ActionTypes.CLEAR_FILTERS_SELECTED_VALUES);



// WEBPACK FOOTER //
// ./src/store/actions/addressingActions.ts